























































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import SupervisiJenazahService from "@/services/SupervisiJenazahService";
import { storeSupervisiJenazah } from "@/store/modules/SupervisiJenazahStore";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import SupervisiJenazahFormDialog from "./SupervisiJenazahFormDialog.vue";
import moment from "moment";

@Component({
  components: { SupervisiJenazahFormDialog },
  beforeRouteEnter(to, from, next) {
    if (userModule.hasPrivilege("supervisi_jenazah", "view")) {
      next();
    } else {
      appModule.sendErrorAlert("Halaman ini tidak bisa diakses...");
      next("/404");
    }
  }
})
export default class SupervisiJenazahListPage extends Vue {
  search: string | null = null;
  dateFrom: string | null = null;
  dateTo: string | null = null;
  dialog = false;
  editItem: any = null;

  tableOptions: any = {
    page: 1,
    itemsPerPage: 10
  };

  get loading() {
    return storeSupervisiJenazah.loading;
  }

  get meta() {
    return storeSupervisiJenazah.meta;
  }

  get listItems() {
    return storeSupervisiJenazah.items.map((item: any, i: number) => ({
      ...item,
      no: (this.meta.current_page - 1) * this.meta.per_page + i + 1
    }));
  }

  get headers() {
    return [
      { text: "No", value: "no", sortable: false, width: 50 },
      { text: "Nomor Formulir", value: "nomor_formulir" },
      { text: "Tanggal", value: "tanggal", width: 140 },
      { text: "Supervisor", value: "supervisor_nama" },
      { text: "Jabatan", value: "supervisor_jabatan" },
      { text: "Aksi", value: "aksi", sortable: false, width: 130 }
    ];
  }

  mounted() {
    this.fetchData();
  }

  @Watch("tableOptions")
  onTableOptionsChange() {
    this.fetchData();
  }

  fetchData() {
    const params: any = {
      page: this.tableOptions.page,
      per_page: this.tableOptions.itemsPerPage
    };
    if (this.search) params.search = this.search;
    if (this.dateFrom) params.date_from = this.dateFrom;
    if (this.dateTo) params.date_to = this.dateTo;

    storeSupervisiJenazah.fetchList(params);
  }

  openForm(item: any) {
    this.editItem = item;
    this.dialog = true;
  }

  printPdf(item: any) {
    SupervisiJenazahService.printPdf(item.id);
  }

  async confirmDelete(item: any) {
    if (!confirm("Yakin hapus data supervisi ini?")) return;

    try {
      await SupervisiJenazahService.destroy(item.id);
      appModule.sendSuccessNotice("Supervisi berhasil dihapus");
      this.fetchData();
    } catch {
      appModule.sendErrorAlert("Gagal menghapus supervisi");
    }
  }

  formatDate(date: string) {
    return date ? moment(date).format("DD MMMM YYYY") : "-";
  }

  beforeDestroy() {
    storeSupervisiJenazah.reset();
  }
}
